module.exports = __webpack_public_path__ + "img/download-icon.97e3ba4e.svg";